import { render, staticRenderFns } from "./RegionPage.vue?vue&type=template&id=4163a1d9&scoped=true"
import script from "./RegionPage.vue?vue&type=script&lang=js"
export * from "./RegionPage.vue?vue&type=script&lang=js"
import style0 from "./RegionPage.vue?vue&type=style&index=0&id=4163a1d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4163a1d9",
  null
  
)

export default component.exports